// extracted by mini-css-extract-plugin
export default {"radioGroup":"DisplayStatistics__radioGroup___T56s7"};